// Events plugin — route flag-gate.
// Ensures /events routes render nothing (redirect home) when the tenant has
// events_module_enabled = false, so a disabled plugin exposes no screens even
// via direct URL navigation. Self-contained: no core changes required.
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import api from '../../lib/api';

export default function EventsGate({ children }) {
  const [state, setState] = useState('loading'); // 'loading' | 'on' | 'off'

  useEffect(() => {
    let active = true;
    api.get('/settings/feature-toggles')
      .then((r) => { if (active) setState(r.data?.events_module_enabled ? 'on' : 'off'); })
      .catch(() => { if (active) setState('off'); });
    return () => { active = false; };
  }, []);

  if (state === 'loading') {
    return (
      <div className="flex items-center justify-center py-24">
        <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
      </div>
    );
  }
  if (state === 'off') return <Navigate to="/" replace />;
  return children;
}
